import React, { useEffect, useState } from "react";
import { Globe, Phone, MessageCircle, Sparkles, Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { WHATSAPP_URL, PHONE, PHONE_TEL } from "../mock";

const AnnouncementBar = () => (
  <div className="w-full bg-[#0b1220] border-b border-white/5 text-[11.5px] md:text-[13px] text-slate-300">
    <div className="max-w-7xl mx-auto px-3 md:px-6 h-9 flex items-center justify-center gap-2 md:gap-3">
      <span className="flex items-center gap-2 flex-shrink-0">
        <span className="relative inline-flex">
          <span className="absolute inline-flex h-2 w-2 rounded-full bg-amber-400 opacity-75 animate-ping" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-amber-400" />
        </span>
        <span className="text-amber-300 font-medium">Limited Time Offer</span>
      </span>
      <span className="hidden md:inline text-slate-400 truncate">
        IELTS / TOEFL / PTE / LanguageCert Exam Fee Cashback · Anywhere in India
      </span>
      <span className="md:hidden text-slate-400 truncate">Exam fee cashback · AU · UK · NZ</span>
      <span className="hidden md:inline text-slate-600">·</span>
      <a
        href="https://www.competitivecareers.in/"
        target="_blank"
        rel="noreferrer"
        className="hidden md:inline text-slate-300 hover:text-white transition-colors"
      >
        Visit main site →
      </a>
    </div>
  </div>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="sticky top-0 z-50">
      <AnnouncementBar />
      <header
        className={`w-full border-b border-white/5 backdrop-blur-md transition-colors duration-300 ${
          scrolled ? "bg-[#0b1220]/90" : "bg-[#0b1220]/75"
        }`}
      >
        <div className="max-w-7xl mx-auto px-3 md:px-6 h-14 md:h-16 flex items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5 md:gap-3 group min-w-0">
            <img
              src="https://customer-assets.emergentagent.com/job_language-test-portal/artifacts/jcixqklr_ccpl-logo-4.2%20%283%29.png"
              alt="Competitive Careers"
              className="h-10 w-10 md:h-12 md:w-12 object-contain rounded-xl bg-black/60 ring-1 ring-white/10 flex-shrink-0"
            />
            <div className="leading-tight min-w-0">
              <div className="text-white font-semibold tracking-tight text-[13.5px] md:text-[15px] truncate">
                Competitive <span className="text-amber-400">Careers</span>
              </div>
              <div className="text-[9.5px] md:text-[10.5px] tracking-[0.16em] md:tracking-[0.18em] uppercase text-slate-400 truncate">
                Pvt. Ltd. · Since 2003
              </div>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-7 text-[14px] text-slate-300">
            <a href="#offer" className="hover:text-white transition-colors">Offer</a>
            <a href="#destinations" className="hover:text-white transition-colors">Destinations</a>
            <a href="#how" className="hover:text-white transition-colors">How it works</a>
            <a href="#stories" className="hover:text-white transition-colors">Stories</a>
            <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href={`tel:${PHONE_TEL}`}
              className="hidden md:inline-flex items-center gap-2 text-slate-300 hover:text-white transition-colors text-[13.5px]"
            >
              <Phone className="h-4 w-4" /> {PHONE}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="hidden sm:inline-flex items-center gap-2 px-3.5 py-2 rounded-full border border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 transition-colors text-[13px]"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
            <Button
              asChild
              className="hidden sm:inline-flex h-9 md:h-10 px-3.5 md:px-4 rounded-full bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/20 text-[13px] md:text-[14px]"
            >
              <a href="#apply" className="inline-flex items-center gap-1.5">
                <Sparkles className="h-4 w-4" /> Apply Free
              </a>
            </Button>

            {/* Mobile menu */}
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <button
                  aria-label="Open menu"
                  className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-xl border border-white/10 bg-white/[0.03] text-white"
                >
                  <Menu className="h-5 w-5" />
                </button>
              </SheetTrigger>
              <SheetContent
                side="right"
                className="w-[86%] sm:w-[380px] bg-[#0b1220] border-l border-white/10 text-white p-0"
              >
                <div className="flex items-center justify-between px-5 py-4 border-b border-white/8">
                  <div className="flex items-center gap-2.5">
                    <img
                      src="https://customer-assets.emergentagent.com/job_language-test-portal/artifacts/jcixqklr_ccpl-logo-4.2%20%283%29.png"
                      alt="Competitive Careers"
                      className="h-10 w-10 object-contain rounded-xl bg-black/60 ring-1 ring-white/10 flex-shrink-0"
                    />
                    <div className="leading-tight">
                      <div className="text-white font-semibold tracking-tight text-[14px]">
                        Competitive <span className="text-amber-400">Careers</span>
                      </div>
                      <div className="text-[9.5px] tracking-[0.16em] uppercase text-slate-400">Pvt. Ltd. · Since 2003</div>
                    </div>
                  </div>
                  <button
                    aria-label="Close menu"
                    onClick={() => setOpen(false)}
                    className="h-9 w-9 grid place-items-center rounded-lg hover:bg-white/5"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
                <nav className="px-5 py-5 space-y-1 text-[15.5px]">
                  {[
                    ["#offer", "The Offer"],
                    ["#destinations", "Destinations"],
                    ["#how", "How it works"],
                    ["#why", "Why CCPL"],
                    ["#stories", "Success stories"],
                    ["#faq", "FAQ"],
                  ].map(([href, label]) => (
                    <a
                      key={href}
                      href={href}
                      onClick={() => setOpen(false)}
                      className="flex items-center justify-between rounded-xl px-3 py-3 text-slate-200 hover:bg-white/5"
                    >
                      <span>{label}</span>
                      <span className="text-slate-500">→</span>
                    </a>
                  ))}
                </nav>
                <div className="px-5 pb-5 pt-2 space-y-2.5 border-t border-white/8">
                  <Button
                    asChild
                    className="w-full h-11 rounded-full bg-red-500 hover:bg-red-600 text-white"
                  >
                    <a href="#apply" onClick={() => setOpen(false)} className="inline-flex items-center justify-center gap-2">
                      <Sparkles className="h-4 w-4" /> Apply Free · 5 quick steps
                    </a>
                  </Button>
                  <Button
                    asChild
                    variant="outline"
                    className="w-full h-11 rounded-full bg-transparent border-emerald-500/40 text-emerald-300 hover:bg-emerald-500/10 hover:text-emerald-200"
                  >
                    <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2">
                      <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
                    </a>
                  </Button>
                  <a
                    href={`tel:${PHONE_TEL}`}
                    className="flex items-center justify-center gap-2 text-slate-300 hover:text-white text-[13.5px] pt-1"
                  >
                    <Phone className="h-4 w-4" /> {PHONE}
                  </a>
                  <a
                    href="https://www.competitivecareers.in/"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center justify-center gap-2 text-slate-400 hover:text-white text-[13px]"
                  >
                    <Globe className="h-4 w-4" /> Visit main site →
                  </a>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
